import {
  Segment as SegmentComp,
  Tab,
  Button,
  Icon,
  Modal,
  Image,
} from '../../components/semantic-ui-antd-adapter'
import { Table } from 'antd'
import { format, differenceInMinutes, parseISO } from 'date-fns'
import { useParams, useHistory } from 'react-router'
import React, { useEffect, useState } from 'react'
import useAxios from 'axios-hooks'
import { Formulario } from './AlunosMatricular'
import { Avatar } from '../../components/Avatar'
import { DisplayFlex } from '../../components/Styles'
import { NavEstrutural } from '../../components/NavEstrutural'
import { Show } from '../../components/Basic'
import { UsuarioModel } from '../../models/UsuarioModel'
const Segment: any = SegmentComp

const AlunosEditar = () => {
  const { cursoId, usuarioId } = useParams<any>()
  return (
    <div>
      <NavEstrutural>Progresso</NavEstrutural>
      <BotaoVoltar />
      <div style={{ margin: '0px 120px' }}>
        <Formulario setSubmited={() => null} cursoId={cursoId} usuarioId={usuarioId} />
      </div>
      <Segment color="orange" style={{ margin: '25px 120px' }}>
        <h2>Acompanhamento de progresso do aluno</h2>
        <Tab
          panes={[
            { menuItem: 'Sessões de estudo', render: () => <Sessoes /> },
            { menuItem: 'Acompanhamento', render: () => <Acompanhamento /> },
            { menuItem: 'Validações Faciais', render: () => <ValidacoesFaciais /> },
          ]}
        />
      </Segment>
    </div>
  )
}

const Label = ({ label, value }) => {
  return (
    <div>
      <div> {label} </div>
      <div>
        {' '}
        <strong>{value}</strong>{' '}
      </div>
    </div>
  )
}

const Sessoes = () => {
  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Início', dataIndex: 'inicio', key: 'inicio' },
    { title: 'Fim', dataIndex: 'fim', key: 'fim' },
    { title: 'Duração', dataIndex: 'duracao', key: 'duracao' },
  ]

  return (
    <div>
      <Table columns={columns} dataSource={[]} />
    </div>
  )
}
const Acompanhamento = () => {
  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Data', dataIndex: 'data', key: 'data' },
    { title: 'Tipo', dataIndex: 'tipo', key: 'tipo' },
    { title: 'Progresso na página', dataIndex: 'progressoPagina', key: 'progressoPagina' },
    { title: 'Progresso no módulo', dataIndex: 'progressoModulo', key: 'progressoModulo' },
    { title: 'Módulo', dataIndex: 'modulo', key: 'modulo' },
  ]

  return (
    <div>
      <Table columns={columns} dataSource={[]} />
    </div>
  )
}
const ValidacoesFaciais = () => {
  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Data', dataIndex: 'data', key: 'data' },
    { title: 'Validador', dataIndex: 'validador', key: 'validador' },
    { title: 'Resultado Validação', dataIndex: 'resultadoValidacao', key: 'resultadoValidacao' },
    { title: '', dataIndex: 'actions', key: 'actions' },
  ]

  return (
    <div>
      <Table columns={columns} dataSource={[]} />
    </div>
  )
}

const BotaoVoltar = () => {
  const history = useHistory()
  return (
    <Button style={{ marginTop: '25px', marginLeft: '120px' }} onClick={history.goBack} circular>
      <Icon name="arrow left" />
      Voltar
    </Button>
  )
}

export { AlunosEditar }
